import { EventEmitter, Injectable, OnDestroy } from '@angular/core';

import { TranslateService } from '@ngx-translate/core';
import { UnsavedChangesDialogComponent } from '../components/unsaved-changes-dialog/unsaved-changes-dialog.component';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';

@Injectable({
  providedIn: 'root',
})
export class HasUnsavedChangesGuard implements OnDestroy {
  public canNavigateAway = true;
  attemptedNavWhileUnsaved$: EventEmitter<null> = new EventEmitter<null>();

  constructor(
    private readonly translateService: TranslateService, //
    private readonly dialog: MatDialog,
  ) {
    window.addEventListener('beforeunload', (event) => {
      if (this.canNavigateAway === false) {
        event.returnValue = this.translateService.instant('UNSAVED_CHANGES_CONFIRM');
      }
    });
  }

  canDeactivate(): boolean {
    if (this.canNavigateAway === false) {
      this.attemptedNavWhileUnsaved$.emit();
    }
    return this.canNavigateAway;
  }

  ngOnDestroy(): void {
    window.removeEventListener('beforeunload', (event) => {
      if (!this.canNavigateAway) {
        event.returnValue = this.translateService.instant('UNSAVED_CHANGES_CONFIRM');
      }
    });
  }

  markAsUnsaved(): void {
    this.canNavigateAway = false;
  }

  markAsSaved(): void {
    this.canNavigateAway = true;
  }

  showUnsavedChangesDialog(): MatDialogRef<UnsavedChangesDialogComponent> {
    return this.dialog.open(UnsavedChangesDialogComponent);
  }
}
